
/*
 * HOUSE OF FURBABY
 * Cart Recommendations
 * Priority: Complementary → Curated Favorites
 */

(() => {
  const containerId = 'hofb-cart-recommendations';
  const collectionHandle = 'cart-recommendation-favorites';
  const root = window.Shopify?.routes?.root || '/';
  const maxProducts = 3;

  let requestNumber = 0;
  let refreshTimer;

  const money = (cents, currency) =>
    new Intl.NumberFormat(
      document.documentElement.lang || 'en-US',
      { style: 'currency', currency: currency || 'USD' }
    ).format(cents / 100);

  const escapeHTML = (value) =>
    String(value ?? '').replace(/[&<>"']/g, char => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    })[char]);

  async function getJSON(url) {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Request failed: ${response.status}`);
    }
    return response.json();
  }

  async function loadRecommendations() {
    const container = document.getElementById(containerId);
    if (!container) return;

    const currentRequest = ++requestNumber;

    try {
      const cart = await getJSON(root + 'cart.js');
      if (currentRequest !== requestNumber) return;

      if (!cart.items.length) {
        container.replaceChildren();
        return;
      }

      const cartIds = new Set(
        cart.items.map(item => item.product_id)
      );

      const sourceIds = [...cartIds].slice(0, 5);

      // Priority 1: Search & Discovery complementary products
      const complementaryResults = await Promise.all(
        sourceIds.map(async id => {
          try {
            const url =
              root + 'recommendations/products.json' +
              '?product_id=' + encodeURIComponent(id) +
              '&limit=10&intent=complementary';

            const data = await getJSON(url);
            return data.products || [];
          } catch (error) {
            console.warn('HOFB complementary request:', error);
            return [];
          }
        })
      );

      if (currentRequest !== requestNumber) return;

      const seen = new Set();

      
function eligible(products) {
  return products.filter(product => {
    if (!product) return false;

    const isAvailable =
      product.available === true ||
      (
        product.available === undefined &&
        product.variants?.some(variant => variant.available)
      );

    if (
      !isAvailable ||
      cartIds.has(product.id) ||
      seen.has(product.id)
    ) return false;

    seen.add(product.id);
    return true;
  });
}


      let products = eligible(
        complementaryResults.flat()
      ).slice(0, maxProducts);

      // Priority 2: Fill empty slots from our curated collection
      if (products.length < maxProducts) {
        try {
          const url =
            root + 'collections/' +
            encodeURIComponent(collectionHandle) +
            '/products.json?limit=100';

          const data = await getJSON(url);
          const fallbackProducts = eligible(data.products || []);

          products = products.concat(
            fallbackProducts.slice(
              0,
              maxProducts - products.length
            )
          );
        } catch (error) {
          console.warn('HOFB fallback collection:', error);
        }
      }

      if (currentRequest !== requestNumber) return;

      if (!products.length) {
        container.replaceChildren();
        return;
      }

      const currency = cart.currency || 'USD';

      container.innerHTML = `
        <div class="hofb-recs">
          <h3 class="hofb-recs__heading">
            Complete Their Look
          </h3>
          <div class="hofb-recs__items">
            ${products.map(product => {
              const variant = product.variants?.find(
                variant => variant.available
              );

              const image =
                product.featured_image?.src ||
                product.featured_image ||
                product.images?.[0]?.src ||
                '';

              
const rawPrice = variant
  ? variant.price
  : product.price;

const isCollectionProduct =
  product.available === undefined;

const price = isCollectionProduct
  ? Math.round(Number(rawPrice) * 100)
  : Number(rawPrice);


              const productURL =
                product.url ||
                root + 'products/' + product.handle;

              return `
                <a class="hofb-recs__item"
                   href="${escapeHTML(productURL)}">
                  ${image ? `
                    <img
                      src="${escapeHTML(image)}"
                      alt="${escapeHTML(product.title)}"
                      loading="lazy"
                    >
                  ` : ''}
                  <span class="hofb-recs__info">
                    <span class="hofb-recs__title">
                      ${escapeHTML(product.title)}
                    </span>
                    <span class="hofb-recs__price">
                      ${money(price, currency)}
                    </span>
                    <span class="hofb-recs__link">
                      Shop This Item →
                    </span>
                  </span>
                </a>
              `;
            }).join('')}
          </div>
        </div>
      `;
    } catch (error) {
      console.warn('HOFB recommendations:', error);
    }
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(loadRecommendations, 300);
  }

  document.addEventListener(
    'DOMContentLoaded',
    scheduleRefresh
  );

  document.addEventListener(
    'cart:updated',
    scheduleRefresh
  );

  document.addEventListener(
    'cart:build',
    scheduleRefresh
  );

  const observer = new MutationObserver(mutations => {
    if (mutations.some(m =>
      m.target.matches?.('[data-products]') ||
      m.target.closest?.('[data-products]')
    )) {
      scheduleRefresh();
    }
  });

  function startObserver() {
    const products = document.querySelector(
      '#CartDrawer [data-products]'
    );

    if (products) {
      observer.observe(products, {
        childList: true,
        subtree: true
      });
    }
  }

  document.addEventListener(
    'DOMContentLoaded',
    startObserver
  );
})();
